import styled from "@emotion/styled";

export const FilterDropdownDoneButton = styled.button`
  background: ${props => props.theme.button.primary.surface.default};
  color: ${props => props.theme.button.primary.text.default};
  padding: 12px 14px 12px 14px;
  border-radius: 14px;
  border: 0;
  width: 100%;
  user-select: none;
  text-align: center;

  &:disabled {
    background: ${props => props.theme.button.primary.surface.waiting};
    color: ${props => props.theme.button.primary.text.waiting};
  }
`;
